import { useMemo, useRef } from "react";
import { useTranslation } from "react-i18next";
import { PageSectionCard } from "../../../components/layout";
import { PageHeader, PageListContainer } from "../../../components/Page";
import DataTableWithPagination from "../../../components/DataTable";
import type { AnomalyRun } from "../../../types/anomaly";

export default function RunListPage() {
  const { t } = useTranslation();
  const tableRef = useRef<{ refresh: () => void } | null>(null);

  const cols = useMemo(
    () => [
      {
        name: t("anomaly.definition"),
        selector: (row: AnomalyRun) => row.definitionName || row.definitionId || "",
      },
      {
        name: t("anomaly.status"),
        selector: (row: AnomalyRun) => row.status || "",
      },
      {
        name: t("anomaly.backend"),
        selector: (row: AnomalyRun) => row.backendUsed || "",
      },
      {
        name: t("anomaly.signals"),
        selector: (row: AnomalyRun) => String(row.signalCount ?? ""),
      },
      {
        name: t("anomaly.startedAt"),
        selector: (row: AnomalyRun) => row.startedAt || "",
      },
      {
        name: t("anomaly.finishedAt"),
        selector: (row: AnomalyRun) => row.finishedAt || "",
      },
      {
        name: t("anomaly.error"),
        selector: (row: AnomalyRun) => row.errorMessage || "",
      },
    ],
    [t]
  );

  return (
      <PageListContainer>
        <PageHeader
          title={t("anomaly.runs")}
          subtitle={t("anomaly.runsSubtitle")}
        />
        <PageSectionCard noPadding>
          <DataTableWithPagination
            ref={tableRef}
            cols={cols}
            fetchUrl="/anomalies/runs"
            searchCollapseToIcon
          />
        </PageSectionCard>
      </PageListContainer>
  );
}
